import { render, staticRenderFns } from "./lighthouseList.vue?vue&type=template&id=1bc18239&"
import script from "./lighthouseList.vue?vue&type=script&lang=js&"
export * from "./lighthouseList.vue?vue&type=script&lang=js&"
import style0 from "./lighthouseList.vue?vue&type=style&index=0&id=1bc18239&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports